import * as DocumentPicker from 'expo-document-picker';
import type {
  UseSpeciesFilePickerOptions,
  UseSpeciesFilePickerResult,
} from './useSpeciesFilePicker.types';

export const useSpeciesFilePicker = ({
  onSelect,
}: UseSpeciesFilePickerOptions): UseSpeciesFilePickerResult => {
  const chooseFile = async (): Promise<void> => {
    try {
      const result = await DocumentPicker.getDocumentAsync({
        copyToCacheDirectory: true,
        type: '*/*',
      });

      if (result.canceled) {
        return;
      }

      const asset = result.assets[0];
      onSelect({
        uri: asset.uri,
        fileName: asset.name,
        fileType: asset.mimeType ?? undefined,
      });
    } catch (error) {
      console.error('Unable to choose file', error);
    }
  };

  return {
    cameraAvailable: false,
    pickFromLibrary: chooseFile,
    takePhoto: chooseFile,
    chooseFile,
    shouldOpenFilePickerDirectly: true,
  };
};
